export default [
  {
    text: 'Удовлетворительное',
    value: 'satisfactory',
  },
  {
    text: 'Хорошее',
    value: 'good',
  },
  {
    text: 'Отличное',
    value: 'excellent',
  },
];
